import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import DropDown from '../../../components/DropDown';
import { useAssignmentContext } from '../../assignments/context';
import MultiDropDown from '../../../components/MultiDropDown';
import PropTypes from 'prop-types';
import { useData } from '../DataContext';

const AssignmentSearchContent = ({ setSelectedCourseName , filters , getFilters }) => {
  const [allCourses, setAllCourses] = useState([]);
  const [allFolders, setAllFolders] = useState([]);
  const [assignmentStatus, setAssignmentStatus] = useState([]);
  const [dropdownKey, setDropdownKey] = React.useState(new Date().getTime().toString());
  const { courseData, folderData, assignedViaData, assignmentStatusData } = useData();

  const {
    allAssignedVia,
    setAllAssignedVia,
    setSearch,
    selectedCourseId,
    setSelectedCourseId,
    selectedFolderId,
    setSelectedFolderId,
    selectedStatusId,
    setSelectedStatusId,
    selectedAssignedViaId,
    setSelectedAssignedViaId,
    setSelectedKeyWord,
    folderUpdateStatus
  } = useAssignmentContext();

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setAllCourses(courseArray)
        : setAllCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllFoldersAsync = async () => {
    try {
      const folderArray = [];
      folderData.map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'Any Folder'
      };
      const FolderArrayResponse = [objData, ...folderArray];
      FolderArrayResponse !== null && FolderArrayResponse !== undefined
        ? setAllFolders(FolderArrayResponse)
        : setAllFolders([objData]);
    } catch (error) {
      console.log(error);
    }
  };

  const replaceSpaceBeforeSecondUppercase = (text) => {
    return text.replace(/([a-z])([A-Z])/g, (match, lowercase, uppercase) => {
      return lowercase + ' ' + uppercase;
    });
  };

  const getAssignmentStatusAsync = async () => {
    try {
      const allAssignmentStatusArray = assignmentStatusData.map((item) => ({
        ...item,
        name: replaceSpaceBeforeSecondUppercase(item.name)
      }));
      setAssignmentStatus(allAssignmentStatusArray);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllAssignedViaAsync = async () => {
    try {
      setAllAssignedVia(assignedViaData);
    } catch (error) {
      console.log(error);
    }
  };

  const setPersistData = () => {
    if (filters !== null && filters !== undefined) {
      if (filters.courseId !== undefined) setSelectedCourseId(filters.courseId);

      setSelectedFolderId(filters.folderId);

      //set persist assignmentstatus filter
      if (assignmentStatusData !== null && assignmentStatusData !== undefined) {
        const updatedAssignmentStatus = assignmentStatusData.map((item) => ({
          ...item,
          isChecked: filters.assignmentStatus.includes(item.id) ? true : item.isChecked
        }));
        setAssignmentStatus(updatedAssignmentStatus);
        const assignmentStatusIds = updatedAssignmentStatus
          .filter((item) => item?.isChecked === true)
          .map((itemId) => itemId.id);
        setSelectedStatusId(assignmentStatusIds);
      }

      //set persist assignedvia filter
      if (assignedViaData !== null && assignedViaData !== undefined) {
        const updatedAssignedVia = assignedViaData.map((item) => ({
          ...item,
          isChecked: filters.assignedVia.includes(item.id) ? true : item.isChecked
        }));
        setAllAssignedVia(updatedAssignedVia);
        const assignedViaIds = updatedAssignedVia
          .filter((item) => item?.isChecked === true)
          .map((itemId) => itemId.id);
        setSelectedAssignedViaId(assignedViaIds);
      }

      setDropdownKey(new Date().getTime().toString());
    }
  };

  useEffect(() => {
    getAllCoursesAsync();
  }, [courseData]);

  useEffect(() => {
    getAllFoldersAsync();
  }, [folderData]);

  useEffect(() => {
    getAssignmentStatusAsync();
  }, [assignmentStatusData]);

  useEffect(() => {
    getAllAssignedViaAsync();
  }, [assignedViaData]);

  useEffect(() => {
    setPersistData();
  }, [filters,assignmentStatusData,assignedViaData]);

  useEffect(() => {
    if (folderUpdateStatus) {
      getFilters();
      getAllFoldersAsync();
    }
  }, [folderUpdateStatus]);

  useEffect(() => {
    setSelectedStatusId([]);
    setSelectedAssignedViaId([]);
  }, []);

  const handleSelectCourse = (event) => {
    const selectedCourseId = parseInt(event.target.value);
    setSelectedCourseId(selectedCourseId);
    const selectedCourse = allCourses.find((course) => course.id === selectedCourseId);
    const selectedCourseName = selectedCourse.name;
    setSelectedCourseName(selectedCourseName);
  };

  const handleSelectFolder = (event) => {
    const selectedFolderId = parseInt(event.target.value);
    setSelectedFolderId(selectedFolderId);
  };

  const handleSelectKeyword = (event) => {
    const selectedKeyWord = event.target.value;
    setSelectedKeyWord(selectedKeyWord);
  };

  const searchHandler = () => {
    setSearch(new Date().getTime());
  };

  const handleChangeAssignmentStatus = (e, assignmentStatus) => {
    const { key } = e;
    const selected = key !== '000' ? assignmentStatus.find((v) => v.id == key) : assignmentStatus;
    if (key === '000') {
      const tempValue = assignmentStatus.map((item) => ({
        ...item,
        isChecked: !assignmentStatus.filter((item) => item?.isChecked !== true).length < 1
      }));
      setAssignmentStatus(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedStatusId('');
      else setSelectedStatusId(ids);
    } else {
      const tempValue = assignmentStatus.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
      setAssignmentStatus(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedStatusId('');
      else setSelectedStatusId(ids);
    }
  };

  const handleChangeAssignedVia = (e, allAssignedVia) => {
    const { key } = e;
    const selected = key !== '000' ? allAssignedVia.find((v) => v.id == key) : allAssignedVia;

    if (key === '000') {
      const tempValue = allAssignedVia.map((item) => ({
        ...item,
        isChecked: !allAssignedVia.filter((item) => item?.isChecked !== true).length < 1
      }));
      setAllAssignedVia(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedAssignedViaId('');
      else setSelectedAssignedViaId(ids);
    } else {
      const tempValue = allAssignedVia.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
      setAllAssignedVia(tempValue);
      const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
      if (ids.length === 0) setSelectedAssignedViaId('');
      else setSelectedAssignedViaId(ids);
    }
  };

  return (
    <>
      <div>
        <div className="row align-items-center mb-4">
          <div className="col-lg-5">
            <h4 className="secondary-title mb-lg-0">Search Assignments</h4>
          </div>
        </div>
        <Row>
          <Col className="col-md-6 col-lg-4 mb-3">
            <DropDown
              key={dropdownKey}
              label="Select Course"
              value={allCourses}
              onChangeHandler={(e) => handleSelectCourse(e)}
              selectedValue={selectedCourseId}
            />
          </Col>

          <Col className="col-md-6 col-lg-4 mb-3">
            <DropDown
              key={dropdownKey}
              label="Select Folder"
              value={allFolders}
              onChangeHandler={(e) => handleSelectFolder(e)}
              selectedValue={selectedFolderId}
            />
          </Col>

          <Col className="col-md-6 col-lg-4 mb-3 position-relative">
            <label className="form-label">Assignment Status</label>
            <MultiDropDown
              key={dropdownKey}
              value={assignmentStatus}
              setValue={setAssignmentStatus}
              dropdownId="assignmentStatus"
              placeholder="Select Assignment Status"
              handleChange={(e) => handleChangeAssignmentStatus(e, assignmentStatus)}
              selectedId={selectedStatusId}
              setSelectedId={setSelectedStatusId}
              description={true}
              selectAllText="All"
            />
          </Col>

          <Col className="col-md-6 col-lg-4 mb-3 mb-lg-0 assignedvia-dropdown">
            <label className="form-label">Assigned Via</label>
            <MultiDropDown
              key={dropdownKey}
              value={allAssignedVia}
              setValue={setAllAssignedVia}
              dropdownId="allAssignedVia"
              placeholder="Select Assigned Via"
              handleChange={(e) => handleChangeAssignedVia(e, allAssignedVia)}
              selectedId={selectedAssignedViaId}
              setSelectedId={setSelectedAssignedViaId}
              selectAllText="All"
            />
          </Col>
          <Col className="col-lg-8">
            <label className="form-label">Keyword</label>
            <div className="d-flex flex-column flex-sm-row gap-4">
              <input
                type="text"
                className="form-control"
                placeholder=" "
                onChange={(e) => handleSelectKeyword(e)}
              />
              <button className="btn outline-btn btn-width" onClick={searchHandler}>
              Search
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

AssignmentSearchContent.propTypes = {
  setSelectedCourseName: PropTypes.func,
  getFilters: PropTypes.func,
  filters: PropTypes.array
};

export default AssignmentSearchContent;
